import { AbstractModel, JsonObject, JsonProperty, DateConverter } from 'projects/core/src/public-api';
import { ShortObject } from '../../project-misc/data/project/short-json-object';
import { User } from 'projects/core/src/lib/login/data/user';
import { SalePeriod } from 'projects/app-misc/src/app/modules/reports/data/sale-period';

@JsonObject('model.SaleStat')
export class SaleStat extends AbstractModel {

	@JsonProperty(Number, 'totalAmt')
	totalAmt?: number;

	@JsonProperty(Number, 'invoicedBalance')
	invoicedBalance?: number;

	@JsonProperty(Number, 'paymentsReceived')
	paymentsReceived?: number;

	@JsonProperty(Number, 'unBilledAmount')
	unBilledAmount?: number;

  @JsonProperty([SalePeriod], 'periods')
  periods?: SalePeriod[];

	@JsonProperty(User, 'salesUser')
	salesUser?: User;

	hideUser?= false;

}
